import React, { useEffect, useMemo, useState } from "react";
import "./Gameboard.css";
import { useNavigate } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import { useWindowWidth } from "../../utils/useGetWidth";
const GameboardNew = ({ course, steps }) => {
  const navigate = useNavigate();
  const width = useWindowWidth()
  const step = useMemo(() => {
    if (width) {

      if (width < 1780) {
        return 4
      }
      if (width < 2000) {
        return 5
      }
      if (width < 2330) {
        return 6
      }
      return 7
    }
  }, [width])
  const [completedCards, setCompletedCards] = useState(0)

  const flattenSteps = (steps) => {
    let result = [];
    for (let i = 0; i < steps.length; i++) {
      const step = steps[i];
      if (step.phase_card_title) {
        result.push({
          ...step,
          phaseCard: true,
        });
      }
      result.push(step);
    }
    return result;
  };

  // const flattenSteps = (steps) => {
  //   let result = [];
  //   for (let i = 0; i < steps.length; i++) {
  //     result.push(steps[i]);
  //     if (steps[i].chapters && steps[i].chapters.length) {
  //       const newList = steps[i].chapters.map((chapter, index) => {
  //         return {
  //           ...chapter,
  //           chapter_title: chapter.title,
  //           chapterIndex: index,
  //           ...steps[i]
  //         };
  //       });
  //       for (let j = 0; j < newList.length; j++) {
  //         result.push(newList[j]);
  //       }
  //     }
  //   }
  //   return result;
  // };

  const stepsList = useMemo(() => {
    if (course?.steps?.length) {
      const allSteps = flattenSteps(course.steps);
      let finalResult = []
      let k = 1
      let congratsAdded = false;
      for (let i = 0; i < allSteps.length; i += step) {
        const currentList = allSteps.slice(i, i + step)
        if (k % 2 == 0) {
          if (currentList.length < step) {
            for (let k = 0; k < step - currentList.length - 1; k++) {
              finalResult.push({
                id: "empty"
              })
            }
            congratsAdded = true;
            finalResult.push({
              id: "congrats"
            })
          }

          finalResult = finalResult.concat(currentList.reverse())
        }
        else {
          finalResult = finalResult.concat(currentList)
          if (currentList.length < step) {
            congratsAdded = true;
            finalResult.push({
              id: "congrats"
            })
          }
        }
        k += 1
      }
      if (!congratsAdded) {
        if (k % 2 == 0) {
          for (let m = 0; m < step - 1; m++) {
            finalResult.push({
              id: "empty"
            })
          }

        }
        finalResult.push({
          id: "congrats"
        })
      }
      return finalResult
    }
    return []
  }, [course, step])

  useEffect(() => {
    const cards = steps?.filter((step) => step?.step_progress == 100)
    setCompletedCards(cards.length)
  }, [steps])

  return (
    <div className="gb-wrapper">
      {course ? (
        <div className="gameboard">
          <div className={`gameboard-wrapper size-${step}`}>
            {stepsList.map((currentStep, index) => {
              const isVerticalConnector = (index + 1) % step === 0 && (index + 1) % (step * 2) !== 0;
              const isFirstConnector = index % step === 0 && index % (step * 2) !== 0;
              const isAfterAdded = (index + 1) % (step * 2) === 0;
              const isBeforeAdded = index % (step * 2) === 0 && index !== 0;
              const isEvenRow = index % (step * 2) < step;

              if (currentStep.id === "congrats") {
                return (
                  <div
                    className={`special-card ${isAfterAdded ? "after" : ""} ${isBeforeAdded ? "before" : ""}`}
                    key={`congrats-${index}`}
                  >
                    <div className="card__header">
                      <div className="phase-card-wrapper">
                        <div className="progress-bar">
                          <span className="progress-bar-fill"></span>
                        </div>
                      </div>
                    </div>
                    <div className="card__content">
                      <span title="Congrats!">Congrats!</span>
                    </div>
                  </div>
                );
              } else if (currentStep.id === "empty") {
                return <div className="" key={`empty-${index}`}></div>;
              } else {
                return (
                  <div
                    className={`gameboard-card ${isEvenRow ? "after" : "before"} ${isVerticalConnector ? "vertical-connector" : ""
                      } ${isAfterAdded ? "after" : ""} ${isBeforeAdded ? "before" : ""} ${isFirstConnector ? "vertical-connector-before" : ""
                      }`}
                    key={currentStep.id}
                  >
                    <div className="card__header"></div>
                    <div className="card__content" style={{
                      fontSize: currentStep.phaseCard ? '22px' : '17px',
                    }}>
                      <span>{!currentStep.phaseCard ? currentStep.title : currentStep.phase_card_title}</span>
                    </div>
                    <div className="card__action__footer">
                      {!currentStep.phaseCard && (
                        <button
                          className="button--link"
                          onClick={() =>
                            navigate(
                              `/courses/step/${currentStep.title
                                .toLowerCase()
                                .replace(/\s+/g, "-")}`,
                              { state: { currentStep, id: course._id, courseCode: course.course_code } }
                            )
                          }
                          disabled={currentStep.locked}
                        >
                          {steps[currentStep.id - 1]?.step_progress === 100
                            ? "Done"
                            : steps[currentStep.id - 1]?.step_progress > 0
                              ? "Continue"
                              : currentStep.locked
                                ? "Locked"
                                : "Start"}
                        </button>
                      )}
                    </div>
                    {!currentStep.phaseCard && <div className="gameboard-card-wrapper">
                      <div className="progress-bar">
                        <span
                          className="progress-bar-fill"
                          style={{
                            width: `${steps[currentStep.id - 1]?.step_progress || 0}%`,
                          }}
                        ></span>
                        <span className="progress-text">
                          {steps[currentStep.id - 1]?.step_progress || 0}%
                        </span>
                      </div>
                    </div>}
                  </div>
                );
              }
            })}

          </div>
        </div>
      ) : (
        <p>Loading course...</p>
      )}
    </div>
  );
};

export default GameboardNew;
